import { combineLatest } from 'rxjs';
import { SistemaService } from './services/sistema.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'site-servicos-ui';

  constructor(private service: SistemaService) { }

  emManutencao = false;
  showManutencaoMessage = false;
  manutencaoMessage = SistemaService.MENSAGEM_PADRAO_MANUTENCAO;
  isLoading = true;

  ngOnInit(): void {
    combineLatest([
      this.service.emManutencao$,
      this.service.showManutencaoMessage$,
      this.service.manutencaoMessage$,
      this.service.isLoading$
    ]).subscribe(([emManutencao, showManutencaoMessage, manutencaoMessage, isLoading]) => {
      this.emManutencao = emManutencao;
      this.showManutencaoMessage = showManutencaoMessage;
      this.manutencaoMessage = manutencaoMessage;
      this.isLoading = isLoading;
    });

    this.service.getConfiguracoes();
  }

  isNavigatorCompatible() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    var compatible = raw ? parseInt(raw[2], 10) >= 99 : true;

    return compatible;
  }

  shouldRenderContent() {
    return (
      this.isNavigatorCompatible() && !this.isLoading && !this.emManutencao
    );
  }

  shouldShowMessageMaintenance() {
    return !this.isLoading && this.emManutencao;
  }

  desativarMensagemManutencao() {
    this.service.esconderMensagemManutencao();
  }
}
